/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Player } from './Player';
import {
    PlayerFromJSON,
    PlayerFromJSONTyped,
    PlayerToJSON,
    PlayerToJSONTyped,
} from './Player';
import type { ManagedTeamDetailsContract } from './ManagedTeamDetailsContract';
import {
    ManagedTeamDetailsContractFromJSON,
    ManagedTeamDetailsContractFromJSONTyped,
    ManagedTeamDetailsContractToJSON,
    ManagedTeamDetailsContractToJSONTyped,
} from './ManagedTeamDetailsContract';
import type { ManagedTeamMetaContract } from './ManagedTeamMetaContract';
import {
    ManagedTeamMetaContractFromJSON,
    ManagedTeamMetaContractFromJSONTyped,
    ManagedTeamMetaContractToJSON,
    ManagedTeamMetaContractToJSONTyped,
} from './ManagedTeamMetaContract';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
    PersonToJSONTyped,
} from './Person';
import type { ResourcePermissionsResponse } from './ResourcePermissionsResponse';
import {
    ResourcePermissionsResponseFromJSON,
    ResourcePermissionsResponseFromJSONTyped,
    ResourcePermissionsResponseToJSON,
    ResourcePermissionsResponseToJSONTyped,
} from './ResourcePermissionsResponse';

/**
 * 
 * @export
 * @interface ManagedTeamResponseContract
 */
export interface ManagedTeamResponseContract {
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamResponseContract
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamResponseContract
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamResponseContract
     */
    clubName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamResponseContract
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamResponseContract
     */
    status: string;
    /**
     * 
     * @type {ManagedTeamMetaContract}
     * @memberof ManagedTeamResponseContract
     */
    meta?: ManagedTeamMetaContract;
    /**
     * 
     * @type {ManagedTeamDetailsContract}
     * @memberof ManagedTeamResponseContract
     */
    details?: ManagedTeamDetailsContract;
    /**
     * 
     * @type {Array<Player>}
     * @memberof ManagedTeamResponseContract
     */
    players: Array<Player>;
    /**
     * 
     * @type {Array<Person>}
     * @memberof ManagedTeamResponseContract
     */
    officials: Array<Person>;
    /**
     * 
     * @type {ResourcePermissionsResponse}
     * @memberof ManagedTeamResponseContract
     */
    permissions?: ResourcePermissionsResponse;
}

/**
 * Check if a given object implements the ManagedTeamResponseContract interface.
 */
export function instanceOfManagedTeamResponseContract(value: object): value is ManagedTeamResponseContract {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('players' in value) || value['players'] === undefined) return false;
    if (!('officials' in value) || value['officials'] === undefined) return false;
    return true;
}

export function ManagedTeamResponseContractFromJSON(json: any): ManagedTeamResponseContract {
    return ManagedTeamResponseContractFromJSONTyped(json, false);
}

export function ManagedTeamResponseContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagedTeamResponseContract {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'clubName': json['clubName'] == null ? undefined : json['clubName'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'status': json['status'],
        'meta': json['meta'] == null ? undefined : ManagedTeamMetaContractFromJSON(json['meta']),
        'details': json['details'] == null ? undefined : ManagedTeamDetailsContractFromJSON(json['details']),
        'players': ((json['players'] as Array<any>).map(PlayerFromJSON)),
        'officials': ((json['officials'] as Array<any>).map(PersonFromJSON)),
        'permissions': json['permissions'] == null ? undefined : ResourcePermissionsResponseFromJSON(json['permissions']),
    };
}

export function ManagedTeamResponseContractToJSON(json: any): ManagedTeamResponseContract {
    return ManagedTeamResponseContractToJSONTyped(json, false);
}

export function ManagedTeamResponseContractToJSONTyped(value?: ManagedTeamResponseContract | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'clubName': value['clubName'],
        'gender': value['gender'],
        'status': value['status'],
        'meta': ManagedTeamMetaContractToJSON(value['meta']),
        'details': ManagedTeamDetailsContractToJSON(value['details']),
        'players': ((value['players'] as Array<any>).map(PlayerToJSON)),
        'officials': ((value['officials'] as Array<any>).map(PersonToJSON)),
        'permissions': ResourcePermissionsResponseToJSON(value['permissions']),
    };
}

